import { useState, useEffect } from 'react';
import { api } from './hrApi';

export default function DirectCall() {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [type, setType] = useState('Enquiry');
  const [notes, setNotes] = useState('');
  const [msg, setMsg] = useState('');
  const [items, setItems] = useState([]);

  const load = () => api('/direct_calls').then(d => setItems(d.items||[])).catch(() => {});
  useEffect(() => { load(); }, []);

  const submit = async () => {
    if (!name.trim()) { setMsg('Caller name is required.'); return; }
    try {
      await api('/direct_call', { method:'POST', body: JSON.stringify({
        caller_name: name, caller_phone: phone, call_type: type, notes }) });
      setMsg('Saved ✓'); setName(''); setPhone(''); setNotes(''); load();
    } catch (e) { setMsg(e.message); }
  };

  return (
    <section className="page on">
      <h2 className="pagetitle display">Direct Call</h2>
      <div className="pagesub">Log incoming calls handled by support staff.</div>
      <div className="card">
        <div style={{display:'grid',gridTemplateColumns:'1.2fr 1fr 1fr',gap:10}}>
          <input value={name} onChange={e=>setName(e.target.value)} placeholder="Caller name *" className="field" style={{padding:'9px 11px',border:'1px solid var(--line)',borderRadius:9}} />
          <input value={phone} onChange={e=>setPhone(e.target.value)} placeholder="Phone number" style={{padding:'9px 11px',border:'1px solid var(--line)',borderRadius:9}} />
          <select value={type} onChange={e=>setType(e.target.value)} style={{padding:'9px 11px',border:'1px solid var(--line)',borderRadius:9}}>
            <option>Enquiry</option><option>Complaint</option><option>Follow-up</option><option>Other</option>
          </select>
        </div>
        <div className="field" style={{marginTop:12}}>
          <textarea rows={3} value={notes} onChange={e=>setNotes(e.target.value)} placeholder="Notes…"
                    style={{width:'100%',padding:'9px 11px',border:'1px solid var(--line)',borderRadius:9}} />
        </div>
        <button className="primary" onClick={submit}>Submit call</button>
        <span className="note" style={{marginLeft:12}}>{msg}</span>
      </div>
      <h3 style={{fontSize:16,margin:'6px 0 12px'}}>My submissions</h3>
      {!items.length ? <div className="loading">No calls logged yet.</div> : (
        <table className="t">
          <thead><tr><th>TIME</th><th>CALLER</th><th>PHONE</th><th>TYPE</th><th>NOTES</th></tr></thead>
          <tbody>{items.map((i,idx) => (
            <tr key={idx}><td>{i.time}</td><td>{i.caller_name}</td><td>{i.caller_phone||'—'}</td>
              <td>{i.call_type}</td><td>{(i.notes||'—').slice(0,120)}</td></tr>
          ))}</tbody>
        </table>
      )}
    </section>
  );
}
